import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Container, TextField, SelectField, DetailPageField } from '../Fields'
import { metricOptions, MetricValuesEnum } from './selectOptions'
import type { DashboardCardConfig } from '../types'

const SelectSubMetric2: React.VFC = () => {
    const { getValues, setValue } = useFormContext<DashboardCardConfig>()
    const firstValue = useWatch<DashboardCardConfig>({ name: 'format.firstPositionDataField' })

    const secondValue = getValues('format.secondPositionDataField')
    const firstEqualsSecond = firstValue === secondValue
    const disabled = !firstValue || firstValue === MetricValuesEnum.NONE

    if (firstEqualsSecond || disabled) {
        setValue('format.secondPositionDataField', MetricValuesEnum.NONE)
    }

    const metric2Options = disabled ? [] : metricOptions.filter(([key]) => key !== firstValue)

    return (
        <SelectField
            label="Sub-Metric 2"
            name="format.secondPositionDataField"
            options={metric2Options}
            disabled={disabled}
        />
    )
}

export const FormatView: React.VFC = () => {
    const type = useWatch<DashboardCardConfig>({ name: 'type' })
    const isContactLogType = type === 'CONTACT_LOG'

    return (
        <Container>
            <TextField label="Card Heading" name="format.cardTitle" />
            <SelectField label="Main Metric" name="format.primaryDataField" options={metricOptions} />
            <TextField label="Metric Name" name="format.mainLabel" />
            <TextField label="Description" name="format.mainLabel2" />
            <TextField label="Description Small" name="format.mainSubLabel" />
            {!isContactLogType && (
                <>
                    <SelectField label="Sub-Metric 1" name="format.firstPositionDataField" options={metricOptions} />
                    <SelectSubMetric2 />
                    <DetailPageField />
                </>
            )}
            <TextField label="Detail Page Heading" name="format.searchDetailTitle" />
        </Container>
    )
}

export default FormatView
